import React from 'react';

import Dropdown from 'ub/components/dropdown/dropdown';

const FONT_SIZES = [8, 9, 10, 11, 12, 14, 16, 18, 20, 22, 24, 26, 28, 36, 48, 72];

function _isValidFontSize(inputStr) {
  const regEx = new RegExp(/^\d+$/); // Only digits
  return regEx.test(inputStr) && inputStr.length < 4;
}

export default class FontSize extends React.Component {
  constructor(props) {
    super(props);

    this._changeFontSize = this._changeFontSize.bind(this);

    this.state = {fontSize: props.fontSize};
  }

  componentWillReceiveProps(newProps) {
    this.setState({
      fontSize: newProps.fontSize
    });
  }

  getOptionsList() {
    return FONT_SIZES.map(size => ({
      value: `${size}`,
      label: `${size}`,
      selected: size === this.state.fontSize,
    }));
  }

  _changeFontSize(size) {
    if (_isValidFontSize(size)) {
      this.props.changeHandler({
        type: 'fontSizeChange',
        value: parseInt(size, 10) || 0,
      });
    } else {
      // set back to old value
      this.setState({fontSize: this.props.fontSize});
    }
  }

  render() {
    return (
      <Dropdown
        className="font-size-dropdown"
        value={`${this.state.fontSize}`}
        options={this.getOptionsList()}
        changeHandler={this._changeFontSize}
        type="input"
      />
    );
  }
}

FontSize.propTypes = {
  fontSize: React.PropTypes.number.isRequired,
  changeHandler: React.PropTypes.func
};



// WEBPACK FOOTER //
// ./src/components/properties-panel/font-size.jsx